import { useMemo } from 'react';

import { createStore } from '@/react/kubernetes/datatables/default-kube-datatable-store';

import { useTableState } from '@@/datatables/useTableState';

import { useEvents } from '../../queries/useEvents';
import { Application } from '../ListView/ApplicationsDatatable/types';

const storageKey = 'k8sCustomResourceEventsDatatable';
const settingsStore = createStore(storageKey, { id: 'Date', desc: true });

export function useCustomResourceEventsTableState() {
  return useTableState(settingsStore, storageKey);
}

export function useCustomResourceEventsTableData(
  environmentId: number,
  namespace: string,
  application?: Application
) {
  const appEventsTableState = useTableState(settingsStore, storageKey);

  const { data: events, ...eventsQuery } = useEvents(environmentId, {
    namespace,
    queryOptions: {
      autoRefreshRate: appEventsTableState.autoRefreshRate * 1000,
    },
  });

  // related events are events that have the application id or the id of any of its pods
  const appEventsData = useMemo(() => {
    if (!application || !events) {
      return [];
    }

    // Get pod UIDs for event correlation
    const podUids =
      application.Pods?.map((pod) => pod.Uid).filter(Boolean) || [];

    // Include events for the application itself (by ID) and all its pods
    const relevantUids = [application.Id, ...podUids];

    return events.filter((event) =>
      relevantUids.includes(event.involvedObject.uid)
    );
  }, [application, events]);

  const appEventWarningCount = useMemo(
    () => appEventsData.filter((event) => event.type === 'Warning').length,
    [appEventsData]
  );

  return {
    appEventsData,
    appEventWarningCount,
    isAppEventsTableLoading: eventsQuery.isInitialLoading,
  };
}
